import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn, formatRelativeTime } from '@/lib';

// Extend dayjs with plugins
dayjs.extend(relativeTime);

export const NotificationCard = ({ icon, title, description, time, read, onClick }) => {
  const { t } = useTranslation();
  const relativeTimeFormatted = formatRelativeTime(time, t);

  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      className="flex items-center justify-start w-full gap-3 p-3 border-b transition cursor-pointer hover:bg-accent/50 focus:outline-none focus:ring-2 focus:ring-interactive"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      aria-label={`${read ? 'Read' : 'Unread'} notification: ${title}`}
    >
      {/* Unread Indicator Dot */}
      <span
        className={cn('flex-shrink-0 w-1 h-1 rounded-full', read ? 'bg-transparent' : 'bg-primary')}
        aria-hidden="true"
      />

      {/* Icon */}
      <div className="flex-shrink-0" aria-hidden="true">
        {icon}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1 justify-between">
          <span className={cn('text-sm truncate', read ? 'font-normal' : 'font-semibold')}>{title}</span>
          <span className="text-xs text-muted font-normal whitespace-nowrap ml-2">{relativeTimeFormatted}</span>
        </div>
        <p className="text-xs text-muted font-normal line-clamp-2">{description}</p>
      </div>
    </div>
  );
};

NotificationCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  read: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};
